import * as Yup from 'yup';
import { AccessoryParticipant } from '@models';

export function useValidationSchema() {
  return Yup.object<AccessoryParticipant>().shape({
    contact: Yup.string().nullable().required(),
  });
}
